import {createSlice} from "@reduxjs/toolkit";

export const initialState = {
    currentPage: 1,
    pageSize: 5,
};

export const educationFieldListTableControllerSlice = createSlice({
    name: 'educationFieldListTableControllerSlice',
    initialState,
    reducers: {
        changeCurrentPage(state, action) {
            state.currentPage = action.payload.page;
            state.pageSize = action.payload.pageSize;
        },
    },
});

export const {changeCurrentPage} = educationFieldListTableControllerSlice.actions;

export default educationFieldListTableControllerSlice.reducer;